<template>
  <div class="orgTable" flexContainer>
    <div class="table_org" flex-1 flexContainer>
      <div class="search_line" flexContainer>
        <span class="title_num">累计用户 {{ user_num }} 个</span>
        <div class="search_a" flexContainer>
          <div class="search_date">
            <span>注册日期筛选：</span>
            <el-date-picker
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              v-model="value_date"
              placeholder="选择日期"
              @change="table_fun"
            ></el-date-picker>
          </div>
          <div class="search_input">
            <el-input
              v-model="search_val"
              clearable
              placeholder="搜索"
              @clear="go_back"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button @click="table_fun">搜索</el-button>
          </div>
        </div>
      </div>
      <div class="table_line" flex-1>
        <el-table
          :data="tableData"
          :height="real_height + 'px'"
          :width="real_width"
          :header-cell-style="headerClass"
          :row-class-name="class_name"
          @sort-change="change_table"
        >
          <el-table-column label="编号" min-width="50">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 + (page - 1) * pageSize }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户头像" width="130">
            <template slot-scope="scope">
              <div><img class="avater" :src="scope.row.avater" alt=""></div>
            </template>
          </el-table-column>
          <el-table-column label="用户id" width="150">
            <template slot-scope="scope">
              <el-popover
                ref="popover"
                placement="top"
                width="200"
                trigger="hover"
                :content="scope.row.userId"
              >
                <span slot="reference" class="org_name_show">{{
                  scope.row.userId
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="用户名" width="100">
            <template slot-scope="scope">
              <el-popover
                ref="popover"
                placement="top"
                width="200"
                trigger="hover"
                :content="scope.row.name"
              >
                <span slot="reference" class="org_name_show">{{
                  scope.row.name
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            min-width="130"
          ></el-table-column>
          <el-table-column
            prop="deviceMark"
            label="设备唯一标识"
            min-width="130"
          >
          <template slot-scope="scope">
              <el-popover
                ref="popover"
                placement="top"
                width="200"
                trigger="hover"
                :content="scope.row.deviceMark"
              >
                <span slot="reference" class="org_name_show">{{
                  scope.row.deviceMark
                }}</span>
              </el-popover>
            </template>
        </el-table-column>
          <el-table-column prop="deviceModel" label="机型" width="150">
            <template slot-scope="scope">
              <el-popover
                ref="popover"
                placement="top"
                width="200"
                trigger="hover"
                :content="scope.row.deviceModel"
              >
                <span slot="reference" class="org_name_show">{{
                  scope.row.deviceModel
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="注册时间"
            width="180"
            sortable="column"
          ></el-table-column>
          <el-table-column
            prop="finalTime"
            label="最近一次使用时间"
            width="180"
            sortable="column"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.finalTime">{{ dayjs(scope.row.finalTime).format('YYYY-MM-DD HH:mm') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="finalIp" label="最后IP" width="130"></el-table-column>
          <el-table-column prop="finalAddr" label="最后IP识别地点" width="130"></el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <span class="show_detail" @click="openDetails(scope.row)"
                >查看详情</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <detail ref="detail_ref"></detail>
    </div>
    <div class="page_line">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        @current-change="table_fun"
        :total="totalPage"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { user_table } from "../../api/user";
import app from "../../mixin/index";
import dayjs from "dayjs";

export default {
  mixins: [app],
  components: {
    detail: () =>
      import(/* webpackChunkName: "design" */ "./components/detail"),
  },
  data() {
    return {
      page: 1,
      pageSize: 50,
      totalPage: "",
      value_date: "",
      search_val: "",
      start: "",
      end: "",
      sort: 0,
      type: 0,
      org_height: document.documentElement.clientHeight,
      real_height: document.documentElement.clientHeight - 238,
      timer: false,
      user_num: "",
      tableData: [],
    };
  },

  mounted() {
    this.real_height = this.org_height - 238;
    const that = this;
    window.addEventListener("resize", function () {
      that.org_height = document.documentElement.clientHeight;
    });
    that.table_fun();
  },
  watch: {
    org_height(val) {
      if (!this.timer) {
        this.real_height = val - 238;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
  methods: {
    dayjs,
    //更改排序
    change_table(column, row) {
      if (column.prop == "createTime") {
        this.type = 0;
      } else if (column.prop == "finalTime") {
        this.type = 1;
      }
      if (column.order == "ascending") {
        this.sort = 1;
      } else {
        this.sort = 0;
      }
      this.table_fun();
    },
    //清空搜索框调用方法
    go_back() {
      this.table_fun();
    },
    //鼠标失焦  时间转化 查询列表
    table_fun() {
      if (this.value_date) {
        var day_pre = new Date(this.value_date[0]);
        var day_aft = new Date(this.value_date[1]);
        this.start = this.formateDate(day_pre);
        this.end = this.formateDate(day_aft);
      } else if (this.value_date == null || this.value_date == "") {
        this.start = "";
        this.end = "";
      }
      console.log(this.start, this.end, "00000");
      let data = {
        search: this.search_val,
        start: this.start,
        end: this.end,
        page: this.page,
        pageCount: this.pageSize,
        sort: this.sort,
        type: this.type,
      };
      user_table(data)
        .then((res) => {
          this.tableData = res.data.userList;
          this.user_num = res.data.amount;
          this.totalPage = res.data.amount;
        })
        .catch((error) => {});
    },
    openDetails(row) {
      this.$refs.detail_ref.init(row);
    },
    //改变table头的颜色
    headerClass() {
      return "background-color:#FAFCFF;height:32px;padding:5px";
    },
    //table隔行改变颜色
    class_name({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "popularLine";
      } else {
        return "colorLine";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.colorLine {
  background-color: #fafcff !important;
}
/deep/.popularLine {
  background-color: #fff !important;
}
@include table;

.avater{
  width: 80px;
  height: 80px;
}
</style>